import { render, staticRenderFns } from "./ImplClass.vue?vue&type=template&id=687f588b&"
import script from "./ImplClass.vue?vue&type=script&lang=js&"
export * from "./ImplClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports